import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBackpackIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M13 10h-2a1.0001 1.0001 0 0 0 0 2h2a1.0001 1.0001 0 0 0 0-2Zm5 0a4.0003 4.0003 0 0 0-3-3.86V5a3 3 0 0 0-6 0v1.14A4 4 0 0 0 6 10a3.9998 3.9998 0 0 0-4 4v3a3 3 0 0 0 3 3h1.18A3.0005 3.0005 0 0 0 9 22h6a3.0004 3.0004 0 0 0 2.82-2H19a3 3 0 0 0 3-3v-3a3.9996 3.9996 0 0 0-1.1716-2.8284A3.9996 3.9996 0 0 0 18 10ZM6 18H5a1.0002 1.0002 0 0 1-1-1v-3a2 2 0 0 1 2-2v6Zm5-13a1.0002 1.0002 0 0 1 1.7071-.7071C12.8946 4.4804 13 4.7348 13 5v1h-2V5Zm5 14a1.0001 1.0001 0 0 1-1 1H9a1.0002 1.0002 0 0 1-1-1v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1Zm0-4.44a3.9099 3.9099 0 0 0-2-.56h-4a3.91 3.91 0 0 0-2 .56V10a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4.56ZM20 17a1.0001 1.0001 0 0 1-1 1h-1v-6a2 2 0 0 1 2 2v3Z"/>
  </SvgIcon>
}

export default LineBackpackIcon
